module.exports = __webpack_public_path__ + "fonts/8ff5720b0cddc622e4bf9b8ebf4aead8.svg";